































































import { Component, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { ValidationErrors } from 'spraypaint/lib-esm/validation-errors'
import { SorewardsProgram } from '@/models/index'
import {
  familyLabelFor,
  SOREWARDS_PROGRAM_TYPE_GROUPS,
  SorewardsProgramTypeGroup
} from '@/models/sorewardsProgramTypes'

@Component({
  name: 'SorewardsProgramCreate'
})
export default class extends Vue {
  private program: SorewardsProgram = new SorewardsProgram()
  private saving = false
  private programTypeQuery = ''

  private get rules() {
    return {
      name: [{
        required: true,
        message: this.$t('sorewardsPrograms.validation.name'),
        trigger: 'blur'
      }],
      programType: [{
        required: true,
        message: this.$t('sorewardsPrograms.validation.programType'),
        trigger: 'change'
      }]
    }
  }

  private familyLabel(family: string) {
    return familyLabelFor(
      family,
      (key) => String(this.$t(key)),
      (key) => this.$te(key)
    )
  }

  private get filteredProgramTypeGroups(): SorewardsProgramTypeGroup[] {
    const query = this.programTypeQuery.trim().toLowerCase()
    if (!query) return SOREWARDS_PROGRAM_TYPE_GROUPS

    return SOREWARDS_PROGRAM_TYPE_GROUPS
      .map((group) => ({
        family: group.family,
        types: group.types.filter((type) => (
          type.toLowerCase().includes(query) ||
          this.familyLabel(group.family).toLowerCase().includes(query)
        ))
      }))
      .filter((group) => group.types.length > 0)
  }

  private filterProgramTypes(query: string) {
    this.programTypeQuery = query
  }

  private onProgramTypeVisibleChange(visible: boolean) {
    if (!visible) this.programTypeQuery = ''
  }

  private createProgram() {
    (this.$refs.dataForm as Form).validate(async(valid: boolean) => {
      if (!valid) return

      this.saving = true
      try {
        const saved = await this.program.save()

        if (!saved || Object.keys(this.program.errors).length > 0) {
          this.printErrors(this.program.errors)
          return
        }

        this.$notify({
          title: String(this.$t('sorewardsPrograms.notifications.createdTitle')),
          message: String(this.$t('sorewardsPrograms.notifications.createdMessage')),
          type: 'success',
          duration: 2000
        })

        this.$router.replace({
          name: 'SorewardsProgramShow',
          params: { id: this.program.id as string }
        }).catch(() => undefined)
      } catch (error) {
        if (error !== 'abort') {
          throw error
        }
      } finally {
        this.saving = false
      }
    })
  }

  private printErrors(errors: ValidationErrors<SorewardsProgram>) {
    for (const error of Object.values(errors)) {
      if (error) {
        this.$notify({
          title: error.title,
          message: error.fullMessage,
          type: 'error',
          duration: 5000
        })
      }
    }
  }
}
